/*
 * This module used for determine what type of page should be rendered and used for request
 */

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

const COOKIE_EXPIRE_DAYS = 10;

function setCookieForAllSubDomains(cname, cvalue) {
  const d = new Date();
  d.setTime(d.getTime() + COOKIE_EXPIRE_DAYS * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  let domain = '';
  const hostArray = location.hostname.split('.');
  if (hostArray.length > 1) {
    const hostArrayReverse = hostArray.reverse();
    domain = `;domain=.${hostArrayReverse[1]}.${hostArrayReverse[0]}`;
  }
  document.cookie = `${cname}=${cvalue};${expires}${domain};path=/`;
}

const KeyTypes = {
  EVENT_OWNER_API_KEY_TYPE: 'event_owner_api_key',
  EVENT_PUBLIC_API_KEY_TYPE: 'event_public_api_key',
  EVENT_PRIVATE_API_KEY_TYPE: 'event_private_api_key',
  ATTENDEE_UID_TYPE: 'attendee_uid',
  ATTENDEE_AND_ORG_UIDS_TYPE: 'attendee_and_org_uids',
  EVENT_NAME_KEY_TYPE: 'event_name_key',
  JWT_TOKEN_TYPE: 'jwt_token',
  KIOSK_TOKEN_TYPE: 'kiosk_token',
};
const KioskKeyTypes = {
  SHOP_KIOSK_TYPE: 'evSB4',
  QR_KIOSK_TYPE: 'evSB3',
  PRESELECTED_PHOTO_TYPE: 'evSB2',
  ALL_PHOTO_TYPE: 'evSB1',
};
const PageTypes = {
  ADMIN_CONSOLE: 'admin_console',
  CURATION_PAGE: 'curation_page',
  OLD_WEBAPP: 'old_webapp',
  PUBLIC_PAGE: 'public_page',
  PRIVATE_PAGE: 'private_page',
  ONE_OF_KIOSK_PAGE: 'kiosks_page', // (sb1, sb2, sb4)
  RIDE_KIOSK: 'ride_kiosk', // (sb3)
  KIOSK_ALBUM_PAGE: 'kiosk_album_page',
};

function GetQueryProvider() {
  this.KEY_TYPE = null; // keep value from KeyTypes
  this.KEY_VALUE = null; // keep value of KeyTypes id or token
  this.EVENT_OWNER_API_KEY = null; // keep value of EVENT_OWNER_API_KEY_TYPE id or token
  this.EVENT_PUBLIC_API_KEY = null; // keep value of EVENT_PUBLIC_API_KEY_TYPE id or token
  this.EVENT_PRIVATE_API_KEY = null; // keep value of EVENT_PRIVATE_API_KEY_TYPE id or token
  this.ATTENDEE_UID = null; // keep attendee id for kiosks (sb2, sb4), old webapp and organization id
  this.ORGANISATION_UID = null; // keep organization uid extracted from query string attOrgId
  this.ATTENDEE_AND_ORG_UIDS = null; // keep value from query string attOrgId
  this.KIOSK_MODE = null; // keep value from query string kioskMode
  this.APP_MODE = null; // set true if query string is app=ios or app=android
  this.NEW_NAME = null; // display the name one of PageTypes
  this.ALBUM_TYPES = {
    isOccoOwnerAlbum: false, // set it when KEY_TYPE is null (should set when we open admin console)
    isEventOwnerAlbum: false, // set it when we have query string eId (it's curation page)
    isAttendeeAlbum: false, // set it when we have query string attId (it's old webapp)
    isAttendeeAlbumFromKiosk: false, // set it when we go to old webapp with paypal payment from kiosk sb1
    isPhotoStreamAlbum: false, // set it when we go to the photo steam album (like https://www.occo.net/?ename=&kioskMode=true)
    isEventPublicAlbum: false, // set it when we have query string pId (it's public album)
    isEventPrivateAlbum: false, // set it when we have query string pvId (it's private album)
  };
  this.KIOSK_TYPES = {
    isAllPhoto: false, // sb1
    isPreselectedPhoto: false, // sb2
    isQRKiosk: false, // sb3
    isShopKiosk: false, // sb4
  };
  let isInitCalled = false; // prevent multiple calls of init function

  this.init = function () {
    if (!isInitCalled) {
      isInitCalled = true;

      this.KIOSK_MODE = getQueryVariable('kioskMode') === 'true';

      const customKioskMode = getQueryVariable('kType');
      if (
        customKioskMode === KioskKeyTypes.PRESELECTED_PHOTO_TYPE ||
        customKioskMode === KioskKeyTypes.ALL_PHOTO_TYPE ||
        customKioskMode === KioskKeyTypes.QR_KIOSK_TYPE ||
        customKioskMode === KioskKeyTypes.SHOP_KIOSK_TYPE
      ) {
        switch (customKioskMode) {
          case KioskKeyTypes.ALL_PHOTO_TYPE:
            this.KIOSK_TYPES.isAllPhoto = true;
            this.NEW_NAME = PageTypes.ONE_OF_KIOSK_PAGE;
            break;
          case KioskKeyTypes.PRESELECTED_PHOTO_TYPE:
            this.KIOSK_TYPES.isPreselectedPhoto = true;
            this.NEW_NAME = PageTypes.ONE_OF_KIOSK_PAGE;
            break;
          case KioskKeyTypes.QR_KIOSK_TYPE:
            this.KIOSK_TYPES.isQRKiosk = true;
            this.NEW_NAME = PageTypes.RIDE_KIOSK;
            break;
          case KioskKeyTypes.SHOP_KIOSK_TYPE:
            this.KIOSK_TYPES.isShopKiosk = true;
            this.NEW_NAME = PageTypes.ONE_OF_KIOSK_PAGE;
            localStorage.setItem('isShopKiosk', true);
            break;
          default:
            break;
        }
      }
      const app = getQueryVariable('app');
      this.APP_MODE = app === 'ios' || app === 'android';

      if (getQueryVariable('attType') === KioskKeyTypes.PRESELECTED_PHOTO_TYPE) {
        this.ALBUM_TYPES.isAttendeeAlbumFromKiosk = true;
      }

      const eId = getQueryVariable('eId');
      if (eId) {
        this.EVENT_OWNER_API_KEY = eId;
        this.KEY_TYPE = KeyTypes.EVENT_OWNER_API_KEY_TYPE;
        this.KEY_VALUE = this.EVENT_OWNER_API_KEY;
        this.NEW_NAME = PageTypes.CURATION_PAGE;
      }

      const pId = getQueryVariable('pId');
      if (pId) {
        this.EVENT_PUBLIC_API_KEY = pId;
        this.KEY_TYPE = KeyTypes.EVENT_PUBLIC_API_KEY_TYPE;
        this.KEY_VALUE = this.EVENT_PUBLIC_API_KEY;
        this.NEW_NAME = PageTypes.PUBLIC_PAGE;
      }

      const kType = getQueryVariable('kType');
      if (kType === 'evSB1') {
        const pvId = getQueryVariable('pvId');
        if (!pvId) throw new Error('Query param &pvId is required');
        this.EVENT_PRIVATE_API_KEY = pvId;
        this.KEY_TYPE = KeyTypes.EVENT_PRIVATE_API_KEY_TYPE;
        this.KEY_VALUE = this.EVENT_PRIVATE_API_KEY;
        this.NEW_NAME = PageTypes.ONE_OF_KIOSK_PAGE;
      } else if (kType === 'evSB2' || kType === 'evSB4' || getQueryVariable('attId')) {
        this.EVENT_PRIVATE_API_KEY = getQueryVariable('pvId');
        const attId = getQueryVariable('attId');
        if (!attId) throw new Error('Query param &attId is required');
        this.ATTENDEE_UID = attId;
        this.KEY_TYPE = KeyTypes.ATTENDEE_UID_TYPE;
        this.KEY_VALUE = this.ATTENDEE_UID;
        this.NEW_NAME = PageTypes.ONE_OF_KIOSK_PAGE;
        this.EVENT_PRIVATE_API_KEY = getQueryVariable('pvId');
        if (!this.KIOSK_MODE) {
          setCookieForAllSubDomains('attId', this.ATTENDEE_UID);
        }
      }

      const pvId = getQueryVariable('pvId');
      if (!kType && pvId) {
        /* NOTE: For "Album for sharing with guests/public (photos never expire)" */
        this.EVENT_PRIVATE_API_KEY = pvId;
        this.KEY_TYPE = KeyTypes.EVENT_PRIVATE_API_KEY_TYPE;
        this.KEY_VALUE = this.EVENT_PRIVATE_API_KEY;
        this.NEW_NAME = PageTypes.PRIVATE_PAGE;
      }

      const attOrgId = getQueryVariable('attOrgId');
      if (attOrgId) {
        this.ATTENDEE_AND_ORG_UIDS = attOrgId;
        this.ATTENDEE_UID = this.ATTENDEE_AND_ORG_UIDS.split('-')[0];
        this.ORGANISATION_UID = this.ATTENDEE_AND_ORG_UIDS.substring(this.ATTENDEE_UID.length + 1, attOrgId.length);
        this.KEY_TYPE = KeyTypes.ATTENDEE_AND_ORG_UIDS_TYPE;
        this.KEY_VALUE = {
          attendee_uid: this.ATTENDEE_UID,
          organisation_uid: this.ORGANISATION_UID,
        };
      }
      switch (this.KEY_TYPE) {
        case null:
          this.ALBUM_TYPES.isOccoOwnerAlbum = true;
          this.NEW_NAME = PageTypes.ADMIN_CONSOLE;
          break;
        case KeyTypes.EVENT_OWNER_API_KEY_TYPE:
          this.ALBUM_TYPES.isEventOwnerAlbum = true;
          this.NEW_NAME = PageTypes.CURATION_PAGE;
          break;
        case KeyTypes.EVENT_PUBLIC_API_KEY_TYPE: {
          this.ALBUM_TYPES.isEventPublicAlbum = true;
          const kioskMode = getQueryVariable('kioskMode');
          this.NEW_NAME = pId && kioskMode ? PageTypes.KIOSK_ALBUM_PAGE : PageTypes.PUBLIC_PAGE;
          break;
        }
        case KeyTypes.EVENT_PRIVATE_API_KEY_TYPE:
          this.ALBUM_TYPES.isEventPrivateAlbum = true;
          if (!customKioskMode) this.NEW_NAME = PageTypes.PRIVATE_PAGE;
          break;
        case KeyTypes.EVENT_NAME_KEY_TYPE:
          this.ALBUM_TYPES.isPhotoStreamAlbum = true;
          break;
        case KeyTypes.ATTENDEE_UID_TYPE:
        case KeyTypes.ATTENDEE_AND_ORG_UIDS_TYPE:
          this.ALBUM_TYPES.isAttendeeAlbum = true;
          if (!customKioskMode) this.NEW_NAME = PageTypes.OLD_WEBAPP;
          break;
        default:
          break;
      }
    }
  };

  /**
   * Generic runtime token activation for token-authenticated requests.
   *
   * @param {string} keyType – auth key type (e.g. "kiosk_token")
   * @param {string} tokenValue – token value sent via transport-specific channel (header/body)
   */
  this.useTokenKey = function (keyType, tokenValue) {
    this.KEY_TYPE = keyType;
    this.KEY_VALUE = tokenValue;
    this.ALBUM_TYPES.isEventPrivateAlbum = true;
  };

  /**
   * Override KEY_TYPE and KEY_VALUE with a kiosk JWT token.
   * Call this after successfully obtaining a token via /auth/kiosk/token.
   *
   * The token is forwarded as the X-Api-Token request header by photoListRetrieve()
   * in occoAPI-module.js — key_type/key_value are NOT written to the request body.
   * KEY_TYPE/KEY_VALUE are still set so other consumers (UI state, non-photo routes)
   * continue to function correctly.
   *
   * @param {string} jwtToken – the JWT string returned by the token endpoint
   */
  this.useKioskToken = function (jwtToken) {
    this.useTokenKey(KeyTypes.KIOSK_TOKEN_TYPE, jwtToken);
  };
}

export default new GetQueryProvider();
